import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertAddPageComponent from './advertAddPage.component';

let advertAddPageModule = angular.module('advertAddPage', [
  uiRouter
])

.component('advertAddPage', advertAddPageComponent)

.name;

export default advertAddPageModule;
